export const APP_NAME = "at.meinstuhl";
